module.exports = __webpack_public_path__ + "img/board_edit-in.aaf6bd3b.png";